import React, { useEffect, useState } from "react";
import SchoolHeader from "../components/SchoolHeader";
import Footer from "../components/Footer";
import {
    Col,
    Container,
    Form,
    Row,
    Card,
    ListGroup,
    Breadcrumb,
    // Dropdown,
} from "react-bootstrap";
import {
    FaFolder,
    FaEye,
} from "react-icons/fa";
// import { IoFilter } from "react-icons/io5";
import { DataGrid } from "@mui/x-data-grid";
import studentServices from "../services/student.services";
import { useParams } from "react-router-dom";
import HospitalHeader from "../components/HospitalHeader";
import LoadingBar from "../components/common-components/toaster/loader/loader";
const allDocuments = [
    {
        title: "Prior Certification",
        param: 'prior_certifications_proof',
        doc_type: 'prior_certificate_front'
    },
    {
        title: "Background Check",
        param: "complete_background_check_proof",
        doc_type: "background_check_proof"
    },
    {
        title: "Physical Cleared Certification",
        param: 'physical_cleared_proof',
        doc_type: "physically_cleared"
    },
    {
        title: "CPR Certification",
        param: 'cpr_proof',
        doc_type: "cpr"
    },
    {
        title: "Covid-19",
        param: 'covid_proof',
        doc_type: "covid_19"
    },
    {
        title: "MMR Certification",
        param: 'mmr_booster_dose2_proof',
        doc_type: "mmr_proof"
    },
    {

        title: "T.B Certificates",
        param: 'td_document',
        doc_type: "tb_doc"
    },
    {
        title: "Additonal Documents",
        param: 'additional_info_proof',
        doc_type: "additional_proof"
    }
]

const StudentFiles = () => {
    const userRole = localStorage.getItem("PageTittle")
    const [loadin, Setloading] = useState(false)
    const [rows, setRows] = useState([]);
    const [resp,setResp] = useState({})
    const [studentDetails, setStudentDetails] = useState({})
    const param = useParams()
    const getStudentDetails = () => {
        studentServices.getStudentProfile({ user_id: param.userid }).then(resp => {
            setStudentDetails(resp.data.data.studentinfo)
            setResp(resp.data.data)
        })
    }
    const columns = [
        { field: "file", headerName: "File Name", width: 400 },

        {
            field: "action",
            headerName: "Action",
            sortable: false,
            width: 150,
            renderCell: (params) => {
                return (
                    <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                        onClick={() => {

                            Setloading(true)
                            const obj = {
                                user_id: param.userid,
                                doc_type: params.row.doc_type,
                                document: params.row.file
                            }
                            studentServices.getStudentDoc(obj).then(resp => {
                                Setloading(false)
                                window.open(resp.data.data.signedUrl);
                            }).catch(err => {
                                Setloading(false)
                            })
                        }}
                    >
                        <span className="actn_icn">
                            <FaEye title="Preview" />
                        </span>
                    </div>
                );
            },
        },
    ];

    useEffect(() => {
        getStudentDetails()
    }, [])
    return (
        <div className="dashbrd_pg ">
            {
                userRole==="School"&&
                <SchoolHeader />
            }
            {
                userRole==="Hospital"&&
                <HospitalHeader/>
            }
           
            
            <div className="fls_cllctn_wrap schl_prfl_pg">
                <Container className="custm_container">
                    {loadin&&
                        <LoadingBar/>}
                    <div className="prfl_wrap">
                        <div className="pg_hdng mb-4">
                            <h2>Student Files</h2>
                            <div className="pg_brdcrmb">
                                <Breadcrumb>
                                    <Breadcrumb.Item >
                                        Dashboard
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item active>
                                    {resp?.programinfo?.program_name}
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item active>
                                       {studentDetails?.first_name}
                                    </Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                        </div>
                        <div className="srch_fld d-inline-block">
                            <Form.Group
                                className="mb-3 position-relative"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                {/* <Form.Control
                                    type="text"
                                    placeholder="Search here"
                                />
                                <div className="srch_icn">
                                    <FaSearch />
                                </div> */}
                                {/* <span className="srch_fltr">
                                    <IoFilter />
                                </span> */}
                                {/* <Dropdown className="srch_fltr">
                                    <Dropdown.Toggle
                                        variant=""
                                        id="dropdown-basic"
                                    >
                                        <IoFilter />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Header>
                                            Filter by
                                        </Dropdown.Header>
                                        <Dropdown.Item href="#">
                                            Name
                                        </Dropdown.Item>
                                        <Dropdown.Item href="#">
                                            Date of Birth
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}
                            </Form.Group>
                        </div>
                        <div className="files_fldrs">
                            <Row>
                                <Col md={3}>
                                    <Card className="pg_card">
                                        <Card.Body>
                                            <div className="fldr_cllctn">
                                                <h6>All Folders</h6>
                                                <div className="fldr_list mt-4">
                                                    <ListGroup variant="flush">
                                                        {allDocuments && allDocuments.map(curr => {
                                                            return (
                                                                <ListGroup.Item>
                                                                    <div className="fldr_div active" onClick={() => {
                                                                        setRows([])
                                                                        let parameters
                                                                        curr.param === "prior_certifications_proof" ?
                                                                            parameters = studentDetails.prior_certifications_proof
                                                                            :
                                                                            curr.param === "complete_background_check_proof" ?
                                                                                parameters = studentDetails.complete_background_check_proof
                                                                                :
                                                                                curr.param === "physical_cleared_proof" ?
                                                                                    parameters = studentDetails.physical_cleared_proof
                                                                                    :
                                                                                    curr.param === "cpr_proof" ?
                                                                                        parameters = studentDetails.cpr_proof
                                                                                        : curr.param === "covid_proof" ? parameters = studentDetails.covid_proof
                                                                                            :
                                                                                            curr.param === 'mmr_booster_dose2_proof' ? parameters = studentDetails.mmr_booster_dose2_proof :
                                                                                                curr.param === 'td_document' ? parameters = studentDetails.td_document : curr.param === 'additional_info_proof' ?
                                                                                                    parameters = studentDetails.additional_info_proof : parameters = null

                                                                        if (parameters) {
                                                                            parameters.map((currd, index) => {
                                                                                currd.id = index
                                                                                currd.doc_type = curr.doc_type
                                                                                setRows(oldMessages => ([currd, ...oldMessages]))
                                                                            })

                                                                        }
                                                                        else {
                                                                            setRows([])
                                                                        }
                                                                    }}>
                                                                        <span className="fldr_icn">
                                                                            <FaFolder />
                                                                        </span>
                                                                        <span className="fldr_txt">
                                                                            {curr.title}
                                                                        </span>
                                                                    </div>
                                                                </ListGroup.Item>
                                                            )
                                                        })}
                                                    </ListGroup>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col md={9}>
                                    <Card className="pg_card">
                                        <Card.Body>
                                            <div className="all_files ">
                                                <div className="docs_tbl">
                                                    <div
                                                        style={{
                                                            height: 400,
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <DataGrid
                                                            rows={rows}
                                                            columns={columns}
                                                            pageSize={5}
                                                            rowsPerPageOptions={[
                                                                5,
                                                            ]}
                                                            checkboxSelection
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Container>
            </div >
            <Footer />
        </div >
    );
};

export default StudentFiles;
